export default "/assets/extreme-active-purple.svg";